import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {ReportsReturnedComponent} from "./components/reports-returned/reports-returned.component";
import {ReportsCanceledComponent} from "./components/reports-canceled/reports-canceled.component";
import {ReportsConsultationCcComponent} from "./components/reports-consultation-cc/reports-consultation-cc.component";
import {
  ReportsLicensesgeneratedComponent
} from "./components/reports-licensesgenerated/reports-licensesgenerated.component";
import {ReportsDashboardComponent} from "./components/reports-dashboard/reports-dashboard.component";
import {ReportsRevokedComponent} from "./components/reports-revoked/reports-revoked.component";
import {ReportsMinisterioComponent} from "./components/reports-ministerio/reports-ministerio.component";
import {ReportsSolicitudesComponent} from "./components/reports-solicitudes/reports-solicitudes.component";
import {
  ReportsRevokedRevocatoriaComponent
} from "./components/reports-revoked-revocatoria/reports-revoked-revocatoria.component";
import {SharedModule} from "../../shared/shared.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatNativeDateModule} from "@angular/material/core";
import {MatInputModule} from "@angular/material/input";
import {DemoNgZorroAntdModule} from "../../core/modules/ng-antd.module";
import {PdfViewerModule} from "ng2-pdf-viewer";
import {MatTableModule} from "@angular/material/table";
import {NgxPaginationModule} from "ngx-pagination";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatSortModule} from "@angular/material/sort";
import {RequestModule} from "../request/request.module";
import {TrackingModule} from "../tracking/tracking.module";



@NgModule({
  declarations: [
    ReportsReturnedComponent,
    ReportsCanceledComponent,
    ReportsConsultationCcComponent,
    ReportsLicensesgeneratedComponent,
    ReportsDashboardComponent,
    ReportsRevokedComponent,
    ReportsMinisterioComponent,
    ReportsSolicitudesComponent,
    ReportsRevokedRevocatoriaComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RequestModule,
    TrackingModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    DemoNgZorroAntdModule,
    PdfViewerModule,
    FormsModule,
    MatTableModule,
    NgxPaginationModule,
    NgbModule,
    MatPaginatorModule,
    MatSortModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ReportsModule { }
